import LessonIssueApiUtils from '../utils/api/lessonIssue';
import { addMessage as addModalMessage } from './modal';
import { addMessage as addFlashMessage } from './flash';
import { hide as hideModal } from './modal';

export const FETCH_LESSON_ISSUE_SENT = 'FETCH_LESSON_ISSUE_SENT';
export const FETCH_LESSON_ISSUE_SUCCEEDED = 'FETCH_LESSON_ISSUE_SUCCEEDED';
export const FETCH_LESSON_ISSUE_FAILED = 'FETCH_LESSON_ISSUE_FAILED';
export const REPORT_LESSON_ISSUE_SENT = 'REPORT_LESSON_ISSUE_SENT';
export const REPORT_LESSON_ISSUE_SUCCEEDED = 'REPORT_LESSON_ISSUE_SUCCEEDED';
export const REPORT_LESSON_ISSUE_FAILED = 'REPORT_LESSON_ISSUE_FAILED';
export const RESOLVE_LESSON_ISSUE_SENT = 'RESOLVE_LESSON_ISSUE_SENT';
export const RESOLVE_LESSON_ISSUE_SUCCEEDED = 'RESOLVE_LESSON_ISSUE_SUCCEEDED';
export const RESOLVE_LESSON_ISSUE_FAILED = 'RESOLVE_LESSON_ISSUE_FAILED';
export const REPORT_AND_RESOLVE_LESSON_ISSUE_SENT =
  'REPORT_AND_RESOLVE_LESSON_ISSUE_SENT';
export const REPORT_AND_RESOLVE_LESSON_ISSUE_SUCCEEDED =
  'REPORT_AND_RESOLVE_LESSON_ISSUE_SUCCEEDED';
export const REPORT_AND_RESOLVE_LESSON_ISSUE_FAILED =
  'REPORT_AND_RESOLVE_LESSON_ISSUE_FAILED';
export const UPDATE_LESSON_ISSUE_TO_REPORT = 'UPDATE_LESSON_ISSUE_TO_REPORT';
export const UPDATE_SELECTED_LESSON_ISSUE_ACTION =
  'UPDATE_SELECTED_LESSON_ISSUE_ACTION';
export const UPDATE_SELECTED_LESSON_ISSUE_REASON =
  'UPDATE_SELECTED_LESSON_ISSUE_REASON';
export const UPDATE_LESSON_ISSUE_COMMENT = 'UPDATE_LESSON_ISSUE_COMMENT';

export function fetchOneSent() {
  return {
    type: FETCH_LESSON_ISSUE_SENT,
  };
}

export function fetchOneSucceeded(data) {
  return {
    type: FETCH_LESSON_ISSUE_SUCCEEDED,
    payload: data,
  };
}

export function fetchOneFailed(error) {
  return {
    type: FETCH_LESSON_ISSUE_FAILED,
  };
}

export function updateSelectedAction(value) {
  return {
    type: UPDATE_SELECTED_LESSON_ISSUE_ACTION,
    payload: {
      value,
    },
  };
}

export function updateSelectedReason(value) {
  return {
    type: UPDATE_SELECTED_LESSON_ISSUE_REASON,
    payload: {
      value,
    },
  };
}

export function updateComment(value) {
  return {
    type: UPDATE_LESSON_ISSUE_COMMENT,
    payload: {
      value,
    },
  };
}

export function reportSent() {
  return {
    type: REPORT_LESSON_ISSUE_SENT,
  };
}

export function reportSucceeded(data) {
  return {
    type: REPORT_LESSON_ISSUE_SUCCEEDED,
    payload: data,
  };
}

export function reportFailed(error) {
  return {
    type: REPORT_LESSON_ISSUE_FAILED,
    payload: {
      message: error.message,
    },
  };
}

export function resolveSent() {
  return {
    type: RESOLVE_LESSON_ISSUE_SENT,
  };
}

export function resolveSucceeded(data) {
  return {
    type: RESOLVE_LESSON_ISSUE_SUCCEEDED,
    payload: data,
  };
}

export function resolveFailed(error) {
  return {
    type: RESOLVE_LESSON_ISSUE_FAILED,
    payload: {
      message: error.message,
    },
  };
}

export function reportAndResolveSent() {
  return {
    type: REPORT_AND_RESOLVE_LESSON_ISSUE_SENT,
  };
}

export function reportAndResolveSucceeded(data) {
  return {
    type: REPORT_AND_RESOLVE_LESSON_ISSUE_SUCCEEDED,
    payload: data,
  };
}

export function reportAndResolveFailed(error) {
  return {
    type: REPORT_AND_RESOLVE_LESSON_ISSUE_FAILED,
    payload: {
      message: error.message,
    },
  };
}

export function fetchOne(id) {
  return (dispatch) => {
    dispatch(fetchOneSent());
    return LessonIssueApiUtils.fetchOne(id).then(
      (data) => dispatch(fetchOneSucceeded(data)),
      (error) => dispatch(fetchOneFailed(error)),
    );
  };
}

export function report(lessonId, issueType, comment) {
  return (dispatch) => {
    dispatch(reportSent());
    return LessonIssueApiUtils.report(lessonId, issueType, comment).then(
      (data) => {
        dispatch(hideModal());
        dispatch(reportSucceeded(data));
        dispatch(
          addFlashMessage(data.message, {
            autoDisappear: true,
            sticky: true,
            type: 'success',
          }),
        );
      },
      (error) => {
        dispatch(reportFailed(error));
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: false,
            type: 'error',
          }),
        );
      },
    );
  };
}

export function resolve(id, selectedAction, selectedReason, comment) {
  return (dispatch) => {
    dispatch(resolveSent());
    return LessonIssueApiUtils.resolve(
      id,
      selectedAction,
      selectedReason,
      comment,
    ).then(
      (data) => {
        dispatch(hideModal());
        dispatch(resolveSucceeded(data));
        dispatch(
          addFlashMessage('Successfully resolved', {
            type: 'success',
            autoDisappear: true,
            sticky: true,
          }),
        );
      },
      (error) => {
        dispatch(resolveFailed(error));
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: false,
            type: 'error',
          }),
        );
      },
    );
  };
}

export function reportAndResolve(lessonId, issueType, action, reason, comment) {
  return (dispatch) => {
    dispatch(reportAndResolveSent());
    return LessonIssueApiUtils.reportAndResolve(
      lessonId,
      issueType,
      action,
      reason,
      comment,
    ).then(
      (data) => {
        dispatch(hideModal());
        dispatch(reportAndResolveSucceeded(data));
        dispatch(
          addFlashMessage('Successfully resolved', {
            type: 'success',
            autoDisappear: true,
            sticky: true,
          }),
        );
      },
      (error) => {
        dispatch(reportAndResolveFailed(error));
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: false,
            type: 'error',
          }),
        );
      },
    );
  };
}
